import i18n from 'i18next'
import { giftCardMobx } from '@mobxStore'
import { setDocumentTitle } from '@utils'

const CUSTOM_TITLE_PAGE = { // 自定义标题
  EXACT: ['/iGc', '/iGc/giftRecord', '/iGc/giftAvailable', '/giftCard', '/giftCard/2'],
  VAGUE: []
}

const CUSTOM_COMMON_TITLE_PAGE = { // 通用标题
  EXACT: [],
  VAGUE: [{
    key: '/giftCard/buy',
    text: 'mkt.giftCard.cardDetail'
  }]
}

// 自定义礼品卡名称
export const getGiftCardName = (cardNameKey: string, customNameKey?: string) => {
  const customCardName = giftCardMobx.decorationInfo?.purchaseDecorates?.customName?.name
  if (!customCardName) return i18n.t(cardNameKey)
  return customNameKey ? i18n.t(customNameKey, { cardName: customCardName }) : customCardName
}

// 判断当前页面是否是礼品卡自定义标题
export const checkGCardCustomPageTitle = () => {
  const pathname = window.location.pathname
  try {
    if (CUSTOM_TITLE_PAGE.EXACT.includes(pathname) ||
    CUSTOM_TITLE_PAGE.VAGUE.some(key => pathname.includes(key)) ||
    CUSTOM_COMMON_TITLE_PAGE.EXACT.some(item => pathname === item.key) ||
    CUSTOM_COMMON_TITLE_PAGE.VAGUE.some(item => pathname.includes(item.key))) {
      return true
    }
    return false
  } catch (error) {
    console.error(error)
  }
}

// 自定义礼品卡页面标题
export const setGCardPageTitle = () => {
  const pathname = window.location.pathname
  try {
    const customCardName = giftCardMobx.decorationInfo?.purchaseDecorates?.customName?.name
    if (!customCardName) return
    if (CUSTOM_TITLE_PAGE.EXACT.includes(pathname) ||
    CUSTOM_TITLE_PAGE.VAGUE.some(key => pathname.includes(key))) {
      setDocumentTitle(customCardName)
    } else {
      const matchPath = CUSTOM_COMMON_TITLE_PAGE.EXACT.find(item => pathname === item.key) || CUSTOM_COMMON_TITLE_PAGE.VAGUE.find(item => pathname.includes(item.key))
      setDocumentTitle(i18n.t(matchPath?.text))
    }
  } catch (error) {
    console.error(error)
  }
}
